import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"

export default class LoadingScene extends Phaser.Scene {
	constructor() {
		super({ key: "LoadingScene" })
		this.planetAssetsLoaded = {
			planet1: false,
			planet2: false,
			planet3: false,
		}
	}

	init() {
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight

		console.log("Loading Scale Factor:", this.scaleFactor)
	}

	preload() {
		console.log("Scale Factor:", this.scaleFactor)

		// Set up loading UI
		this.setupLoadingUI()

		// Load core assets first (UI, common elements)
		this.loadCoreAssets()

		// Load Planet 1 assets immediately
		//this.loadPlanet1Assets()
	}

	setupLoadingUI() {
		this.add
			.image(this.gameW / 2, this.gameH / 2, "spaceBG2")
			.setScale(this.scaleFactor * 0.5)

		let gameLogo = this.add.sprite(
			this.gameW / 2,
			this.gameH / 2 - 60 * this.scaleFactor,
			"gameLogo",
		)
		gameLogo.setScale(this.scaleFactor * 0.5)

		let bgBar = this.add
			.sprite(0, 0, "loadingBar")
			.setScale(this.scaleFactor * 0.5)
		let barXScale = 2
		bgBar.setPosition(this.gameW / 2, this.gameH / 2 + 150 * this.scaleFactor)

		let barW = bgBar.width
		let barH = bgBar.height

		// Set up progress bar
		let progressBar = this.add.graphics()
		progressBar.setPosition(bgBar.x - barW, bgBar.y - barH / 2)
		progressBar.mask = new Phaser.Display.Masks.BitmapMask(this, bgBar)

		// Listen to progress event
		this.load.on(
			"progress",
			function (value) {
				progressBar.clear()
				progressBar.fillStyle(0x7ff9ff, 1)
				progressBar.fillRect(
					0,
					0,
					value * barW * barXScale,
					barH + 100 * this.scaleFactor,
				)
			},
			this,
		)

		let loadingSnail = this.add
			.sprite(
				bgBar.x / 2 + 120 * this.scaleFactor,
				bgBar.y - 34 * this.scaleFactor,
				"loadingSnail",
			)
			.setScale(0.3 * this.scaleFactor)
		loadingSnail.setDepth(0.1)

		let loadingText = this.add.text(
			bgBar.x,
			bgBar.y + 20 * this.scaleFactor,
			"Mission Loading...",
			{
				fontFamily: "Space Grotesk",
				fontSize: 14 * this.scaleFactor,
				color: "#FFFFFF",
				align: "center",
				fontWeight: "700",
				fontStyle: "bold",
				resolution: 2,
			},
		)
		loadingText.setOrigin(0.5)
		loadingText.setDepth(0.1)

		this.loadingText = loadingText
	}

	loadCoreAssets() {
		// Load all UI assets that are used across all planets
		this.load.image("cockpitBack", "assets/images/cockpit/Cockpit_Back.png")
		this.load.image("emptyStar", "assets/images/ui/emptyStar.png")
		this.load.image("filledStar", "assets/images/ui/filledStar.png")
		this.load.image("blankCertificate", "assets/images/ui/blankCertificate.png")
		this.load.image("signature", "assets/images/ui/signature.png")
		this.load.image("alertIcon2", "assets/images/ui/alert_blur.png")
		this.load.image("container", "assets/images/ui/Container_Popup_Empty.png")
		this.load.image("rightButton", "assets/images/ui/RoundButton_Right.png")
		this.load.image("leftButton", "assets/images/ui/RoundButton_Left.png")
		this.load.image("detailsBtn", "assets/images/ui/Details.png")
		this.load.image("activityBtn", "assets/images/ui/Activity.png")
		this.load.image("holder", "assets/images/ui/Holder.png")
		this.load.image("longContainer", "assets/images/ui/LongContainer_Popup.png")
		this.load.image("wideContainer", "assets/images/ui/WideContainer_Popup.png")
		this.load.image("activeButton", "assets/images/ui/ActiveButton.png")
		this.load.image("closeButton", "assets/images/ui/CloseButton.png")
		this.load.image("tabletButton", "assets/images/ui/TabletButton.png")
		this.load.image("scaleUpButton", "assets/images/ui/ScaleUpButton.png")
		this.load.image("scaleUpButtonNew", "assets/images/ui/ScaleUpButtonNew.png")
		this.load.image("scaleDownButton", "assets/images/ui/ScaleDownButton.png")
		this.load.image("scaleDownButtonNew", "assets/images/ui/ScaleDownButtonNew.png")
		this.load.image("notificationBell", "assets/images/ui/NotifBell.png")
		this.load.image(
			"miniNotificationBell",
			"assets/images/ui/mini-notification.png",
		)
		this.load.image("creatureLoading", "assets/images/ui/creatureLoading.png")
		this.load.image("indicator", "assets/images/ui/Indicator.png")
		this.load.image("databaseButton", "assets/images/ui/databaseIcon.png")
		this.load.image("fieldGuideButton", "assets/images/ui/fieldGuideIcon.png")
		this.load.image("fieldGuideLocked", "assets/images/ui/fieldGuideLocked.png")
		this.load.image("emailButton", "assets/images/ui/emailIcon.png")
		this.load.image("emailLocked", "assets/images/ui/emailLocked.png")
		this.load.image("alertsButton", "assets/images/ui/Alerts.png")
		this.load.image("alertsLocked", "assets/images/ui/alertsLocked.png")
		this.load.image("emailSeparator", "assets/images/ui/EmailLineSeparator.png")
		this.load.image("unreadEmail", "assets/images/ui/UnreadEmail.png")
		this.load.image("readEmail", "assets/images/ui/ReadEmail.png")
		this.load.image("safeEmailPill", "assets/images/ui/safeEmailPill.png")
		this.load.image("welcomeMedinaut", "assets/images/ui/WelcomeMedinaut.png")
		this.load.image("tutorialBtn", "assets/images/ui/TutorialBtn.png")
		this.load.image("tab1Active", "assets/images/ui/tab1Active.png")
		this.load.image("tab2Active", "assets/images/ui/tab2Active.png")
		this.load.image("tab1Inactive", "assets/images/ui/tab1Inactive.png")
		this.load.image("tab2Inactive", "assets/images/ui/tab2Inactive.png")
		this.load.image("tab1Contents", "assets/images/ui/Tab1Contents.png")
		this.load.image("tab2Contents", "assets/images/ui/Tab2Contents.png")
		this.load.image("lOContainer", "assets/images/ui/LOContainer.png")
		this.load.image("lOImageHolder", "assets/images/ui/LOImageHolder.png")
		this.load.image("lOOverlay", "assets/images/ui/LOOverlay.png")
		this.load.image("lOOpened", "assets/images/ui/LOOpened.png")
		this.load.image("lOProgressBar0", "assets/images/ui/LOProgressBar0.png")
		// this.load.image("lOProgressBar1", "assets/images/ui/LOProgressBar1.png")
		// this.load.image("lOProgressBar2", "assets/images/ui/LOProgressBar2.png")
		// this.load.image("lOProgressBar3", "assets/images/ui/LOProgressBar3.png")
		// this.load.image("lOProgressBar4", "assets/images/ui/LOProgressBar4.png")
		this.load.image("lOProgressBar5", "assets/images/ui/LOProgressBar5.png")
		// this.load.image("lOProgressBar6", "assets/images/ui/LOProgressBar6.png")
		// this.load.image("lOProgressBarStar5", "assets/images/ui/LOProgressBarStars5.png")
		this.load.image("starImage", "assets/images/ui/StarImage.png")
		//this.load.image("lOProgressBarStar6", "assets/images/ui/LOProgressBarStars6.png")
		this.load.image("missionHolder01", "assets/images/ui/MissionHolder01.png")
		this.load.image("missionHolder02", "assets/images/ui/MissionHolder02.png")
		this.load.image("missionHolder03", "assets/images/ui/MissionHolder03.png")
		this.load.image("closeTutorialHolder", "assets/images/ui/CloseTutorialHolder.png")
		this.load.image("closeTutorialButton", "assets/images/ui/CloseTutorialButton.png")
		this.load.image("whatsMyMissionHolder", "assets/images/ui/WhatsMyMissionHolder.png")
		this.load.image("whatsMyMissionButton", "assets/images/ui/WhatsMyMissionButton.png")
		this.load.image("spaceMedal", "assets/images/ui/Space medal.png")
		this.load.image("toTheCockpitBtn", "assets/images/ui/ToTheCokpitBtn.png")
		this.load.image("tutorialPressRight", "assets/images/ui/tutorialPressRight.png")
		this.load.image("whatItEatsTip", "assets/images/ui/whatItEatsTip.png")
		this.load.image("pressToFeedTip", "assets/images/ui/pressToFeedTip.png")
		this.load.image('particle1', 'assets/images/ui/particle1.png')
		this.load.image('particle2', 'assets/images/ui/particle2.png')
		// this.load.image(
		// 	"creature01_fullView",
		// 	"assets/images/creatureFullView/creature01FullView.png",
		// )
		// this.load.image(
		// 	"creature02_fullView",
		// 	"assets/images/creatureFullView/creature02FullView.png",
		// )
		// this.load.image(
		// 	"creature03_fullView",
		// 	"assets/images/creatureFullView/creature03FullView.png",
		// )
		// this.load.image(
		// 	"creature04_fullView",
		// 	"assets/images/creatureFullView/creature04FullView.png",
		// )
		// this.load.image(
		// 	"creature05_fullView",
		// 	"assets/images/creatureFullView/creature05FullView.png",
		// )
		// this.load.image(
		// 	"creature06_fullView",
		// 	"assets/images/creatureFullView/creature06FullView.png",
		// )
		// this.load.image(
		// 	"creature07_fullView",
		// 	"assets/images/creatureFullView/creature07FullView.png",
		// )
		// this.load.image(
		// 	"creature08_fullView",
		// 	"assets/images/creatureFullView/creature08FullView.png",
		// )
		// this.load.image(
		// 	"creature09_fullView",
		// 	"assets/images/creatureFullView/creature09FullView.png",
		// )
		// this.load.image(
		// 	"creature10_fullView",
		// 	"assets/images/creatureFullView/creature10FullView.png",
		// )
		// this.load.image(
		// 	"creature11_fullView",
		// 	"assets/images/creatureFullView/creature11FullView.png",
		// )
		// this.load.image(
		// 	"creature12_fullView",
		// 	"assets/images/creatureFullView/creature12FullView.png",
		// )
		// this.load.image(
		// 	"creature13_fullView",
		// 	"assets/images/creatureFullView/creature13FullView.png",
		// )
		// this.load.image(
		// 	"creature14_fullView",
		// 	"assets/images/creatureFullView/creature14FullView.png",
		// )
		// this.load.image(
		// 	"creature15_fullView",
		// 	"assets/images/creatureFullView/creature15FullView.png",
		// )
		// this.load.image(
		// 	"creature16_fullView",
		// 	"assets/images/creatureFullView/creature16FullView.png",
		// )
		// this.load.image(
		// 	"creature17_fullView",
		// 	"assets/images/creatureFullView/creature17FullView.png",
		// )
		// this.load.image(
		// 	"creature18_fullView",
		// 	"assets/images/creatureFullView/creature18FullView.png",
		// )

		this.load.image(
			"creatureScaleUpButton",
			"assets/images/buttons/creatureScaleUpButton.png",
		)
		this.load.image(
			"creatureScaleDownButton",
			"assets/images/buttons/creatureScaleDownButton.png",
		)

		this.load.image(
			"replayButton",
			"assets/images/buttons/replayButton.png",
		)
		this.load.image(
			"continueButton",
			"assets/images/buttons/continueButton.png",
		)

		this.load.image("rUSurePanel", "assets/images/ui/rUSurePanel.png")
		this.load.image("alertIcon", "assets/images/ui/Icon_Alert.png")
		this.load.image("captchaSelected", "assets/images/ui/CaptchaSelected.png")
		this.load.image("alertOops", "assets/images/ui/alertOops.png")
		this.load.image("oopsBG", "assets/images/ui/oopsBG.png")

		this.load.image("addEntry", "assets/images/ui/addEntry.png")
		this.load.image("tabletStatusBar", "assets/images/ui/TabletStatusBar.png")
		this.load.image("battery", "assets/images/ui/Battery.png")
		this.load.image("wifiOn", "assets/images/ui/Wifi.png")
		this.load.image("wifiOff", "assets/images/ui/WifiOff.png")
		this.load.image("signal", "assets/images/ui/Signal.png")
		this.load.image("bluetooth", "assets/images/ui/Bluetooth.png")
		this.load.image("activityPill", "assets/images/ui/ActivityPill.png")

		this.load.image("tabletBG", "assets/images/ui/TabletBG.png")
		this.load.image("wideBtn", "assets/images/buttons/wideBtn.png")
		this.load.image("miniWideBtn", "assets/images/buttons/miniWideBtn.png")
		this.load.image("soundOff", "assets/images/ui/soundOff.png")
		this.load.image("soundOn", "assets/images/ui/soundOn.png")
		this.load.image("okBtn", "assets/images/buttons/okBtn.png")
		this.load.image("saveBtn", "assets/images/buttons/saveBtn.png")
		this.load.image("launchBtn", "assets/images/buttons/launch.png")
		//instrBar
		this.load.image("PlanetNamePill", "assets/images/ui/PlanetNamePill.png")
		this.load.image("instrBar", "assets/images/ui/instrBar.png")
		this.load.image("instructionsBar", "assets/images/ui/instructionsBar.png")
		this.load.image("centre", "assets/images/ui/centre.png")
		this.load.image("left-edge", "assets/images/ui/left-edge.png")
		this.load.image("right-edge", "assets/images/ui/right-edge.png")
		this.load.image("morePlanets", "assets/images/ui/morePlanets.png")
		this.load.image("rocketFumes", "assets/images/ui/rocketFumes.png")
		this.load.image("radarContainer", "assets/images/ui/radarContainer.png")
		this.load.image("searchIcon", "assets/images/ui/SearchIcon.png")
		this.load.image("activePageIndicator", "assets/images/ui/pageActive.png")
		this.load.image(
			"inactivePageIndicator",
			"assets/images/ui/pageInactive.png",
		)
		this.load.image("forwardButton", "assets/images/ui/forwardButton.png")
		this.load.image("backButton", "assets/images/ui/backButton.png")
		this.load.image("normalWideBtn", "assets/images/buttons/normalWideBtn.png")
		this.load.image(
			"customizationBG",
			"assets/images/backgrounds/customizationBG.png",
		)
		this.load.image(
			"closeTabletButton",
			"assets/images/ui/CloseTabletButton.png",
		)
		// this.load.image(
		// 	"missionIntroBG",
		// 	"assets/images/backgrounds/mission-intro.png",
		// )

		//customization
		this.load.image(
			"astronaut01",
			"assets/images/customization/Astronaut01.png",
		)
		this.load.image(
			"astronaut02",
			"assets/images/customization/Astronaut02.png",
		)
		this.load.image(
			"astronaut03",
			"assets/images/customization/Astronaut03.png",
		)
		this.load.image(
			"spaceship01",
			"assets/images/customization/Spaceship01.png",
		)
		this.load.image(
			"spaceship01_noShadow",
			"assets/images/customization/Spaceship01_NoShadow.png",
		)

		this.load.image(
			"spaceship02",
			"assets/images/customization/Spaceship02.png",
		)
		this.load.image(
			"spaceship02_noShadow",
			"assets/images/customization/Spaceship02_NoShadow.png",
		)
		this.load.image(
			"spaceship03",
			"assets/images/customization/Spaceship03.png",
		)
		this.load.image(
			"spaceship03_noShadow",
			"assets/images/customization/Spaceship03_NoShadow.png",
		)
		this.load.image(
			"ornament01",
			"assets/images/customization/OrnamentDisco.png",
		)
		this.load.image(
			"ornament02",
			"assets/images/customization/OrnamentDoggo.png",
		)
		this.load.image(
			"ornament03",
			"assets/images/customization/OrnamentFrame.png",
		)
		this.load.image(
			"customizationContainer",
			"assets/images/ui/customizationContainer.png",
		)
		//customization default
		this.load.image(
			"astronaut01Default",
			"assets/images/customization/CharacterBlueDefault.png",
		)
		this.load.image(
			"astronaut02Default",
			"assets/images/customization/CharacterYellowDefault.png",
		)
		this.load.image(
			"astronaut03Default",
			"assets/images/customization/CharacterPurpleDefault.png",
		)
		this.load.image(
			"spaceship01Default",
			"assets/images/customization/ShipBlueDefault.png",
		)
		this.load.image(
			"spaceship02Default",
			"assets/images/customization/ShipYellowDefault.png",
		)
		this.load.image(
			"spaceship03Default",
			"assets/images/customization/ShipPurpleDefault.png",
		)
		this.load.image(
			"ornament01Default",
			"assets/images/customization/OrnamentBlueDefault.png",
		)
		this.load.image(
			"ornament02Default",
			"assets/images/customization/OrnamentYellowDefault.png",
		)
		this.load.image(
			"ornament03Default",
			"assets/images/customization/OrnamentPurpleDefault.png",
		)

		//customization active
		this.load.image(
			"astronaut01Active",
			"assets/images/customization/CharacterBlueActive.png",
		)
		this.load.image(
			"astronaut02Active",
			"assets/images/customization/CharacterYellowActive.png",
		)
		this.load.image(
			"astronaut03Active",
			"assets/images/customization/CharacterPurpleActive.png",
		)
		this.load.image(
			"spaceship01Active",
			"assets/images/customization/ShipBlueActive.png",
		)
		this.load.image(
			"spaceship02Active",
			"assets/images/customization/ShipYellowActive.png",
		)
		this.load.image(
			"spaceship03Active",
			"assets/images/customization/ShipPurpleActive.png",
		)
		this.load.image(
			"ornament01Active",
			"assets/images/customization/OrnamentBlueActive.png",
		)
		this.load.image(
			"ornament02Active",
			"assets/images/customization/OrnamentYellowActive.png",
		)
		this.load.image(
			"ornament03Active",
			"assets/images/customization/OrnamentPurpleActive.png",
		)

		//indicators
		this.load.image(
			"radarIndicator",
			"assets/images/indicators/radarIndicator.png",
		)
		this.load.image(
			"tabAppIndicator",
			"assets/images/indicators/tabAppIndicator.png",
		)
		this.load.image(
			"tabsIndicator",
			"assets/images/indicators/tabsIndicator.png",
		)
		this.load.image(
			"dietIndicator",
			"assets/images/indicators/dietIndicator.png",
		)
		this.load.image(
			"feedIndicator",
			"assets/images/indicators/feedIndicator.png",
		)
		this.load.image(
			"tabletIndicator",
			"assets/images/indicators/tabletIndicator.png",
		)
		this.load.image(
			"ultraWideIndicator",
			"assets/images/indicators/ultraWideIndicator.png",
		)
		this.load.image(
			"foodNumberIndicator",
			"assets/images/indicators/foodNumberIndicator.png",
		)
		this.load.image(
			"foodSaveIndicator",
			"assets/images/indicators/foodSaveIndicator.png",
		)
		this.load.image(
			"scanIndicator",
			"assets/images/indicators/scanIndicator.png",
		)
		this.load.image(
			"closeTabletIndicator",
			"assets/images/indicators/closeTabletIndicator.png",
		)
		this.load.image(
			"wifiIndicator",
			"assets/images/indicators/wifiIndicator.png",
		)
		this.load.image("buttonTip", "assets/images/indicators/buttonIndicator.png")
		this.load.image("foodIndicator", "assets/images/tooltips/foodTip.png")
		this.load.image("foodItemsTip", "assets/images/tooltips/foodItemsTip.png")
		this.load.image("thisIsYourTabletTip", "assets/images/tooltips/thisIsYourTabletTip.png")
		this.load.image("addFoodTip", "assets/images/tooltips/addFoodTip.png")
		this.load.image("helpDeskTip", "assets/images/tooltips/helpDeskTip.png")
		this.load.image("leftButtonTip", "assets/images/tooltips/leftButtonTip.png")
		this.load.image("wiFiTooltip", "assets/images/tooltips/wifiTooltip.png")
		this.load.image("incorrectWifiTooltip", "assets/images/tooltips/incorrectWifiTooltip.png")

		this.load.image("fuelHolder", "assets/images/ui/fuelPill.png")
		this.load.image("creatureTally", "assets/images/ui/creatureTally.png")
		this.load.image("fuelEmpty", "assets/images/ui/fuelEmpty.png")
		this.load.image("fuelFull", "assets/images/ui/fuelFull.png")
		this.load.image("fuelHalf", "assets/images/ui/fuelHalf.png")
		this.load.image("fuelState3", "assets/images/ui/fuelState3.png")
		this.load.image("fuelState4", "assets/images/ui/fuelState4.png")
		this.load.image("fuelState5", "assets/images/ui/fuelState5.png")
		this.load.image("appHolder", "assets/images/ui/AppsHolder.png")

		// this.load.image('mouse', 'assets/images/Learning Outcome stills/a mouse.png')
		// this.load.image('printer', 'assets/images/Learning Outcome stills/a printer.png')
		// this.load.image('desktops', 'assets/images/Learning Outcome stills/desktops.png')
		// this.load.image('email', 'assets/images/Learning Outcome stills/email.png')
		// this.load.image('entering', 'assets/images/Learning Outcome stills/entering numbers letters.png')
		// this.load.image('forms', 'assets/images/Learning Outcome stills/forms.png')
		// this.load.image('help desk', 'assets/images/Learning Outcome stills/help desk.png')
		// this.load.image('laptops', 'assets/images/Learning Outcome stills/laptops.png')
		// this.load.image('logging time', 'assets/images/Learning Outcome stills/logging time.png')
		// this.load.image('otp', 'assets/images/Learning Outcome stills/otp.png')
		// this.load.image('required fields', 'assets/images/Learning Outcome stills/required fields.png')
		// this.load.image('wi fi', 'assets/images/Learning Outcome stills/wi fi.png')

		//planets
		this.load.image("planet01", "assets/images/planets/Planet_1.png")
		this.load.image("planet02", "assets/images/planets/Planet_2.png")
		this.load.image(
			"planet02Locked",
			"assets/images/planets/Planet_2Locked.png",
		)
		this.load.image("planet03", "assets/images/planets/Planet_3.png")
		this.load.image(
			"planet03Locked",
			"assets/images/planets/Planet_3Locked.png",
		)
		this.load.image(
			"planet04Locked",
			"assets/images/planets/Planet_4Locked.png",
		)
		this.load.image(
			"planet05Locked",
			"assets/images/planets/Planet_5Locked.png",
		)
		this.load.image(
			"planet06Locked",
			"assets/images/planets/Planet_6Locked.png",
		)
		this.load.image(
			"planet07Locked",
			"assets/images/planets/Planet_7Locked.png",
		)
		// this.load.image('planet08', 'assets/images/planets/Planet08.png')
		// this.load.image('planet09', 'assets/images/planets/Planet09.png')
		this.load.image("planetEdge", "assets/images/planets/PlanetsEdge.png")
		this.load.image("planetActive", "assets/images/ui/Planet_Active.png")
		this.load.image("planetComplete", "assets/images/ui/Planet_Complete.png")
		this.load.image("planetLocked", "assets/images/ui/PlanetLocked.png")

		// Load common background and UI elements
		this.load.image("spaceBG", "assets/images/backgrounds/space_BG.png")
		this.load.image("circle", "assets/images/circle.png")
		this.load.image("safeZone", "assets/images/SafeZone.png")
		this.load.image("tabletView", "assets/images/ui/tabletImage.png")

		this.load.image("radar", "assets/images/ui/radarBg.png")
		this.load.image("radarDot", "assets/images/ui/radar_dot.png")
		this.load.image("radarWinContainer", "assets/images/ui/radarContainerWin.png")

		//cockpit
		this.load.image(
			"dischargeButton",
			"assets/images/buttons/dischargeButton.png",
		)
		this.load.image(
			"feedingPanelUnscaled",
			"assets/images/cockpit/feedingUnscaled.png",
		)
		this.load.image(
			"taskListPanelUnscaled",
			"assets/images/cockpit/taskUnscaled.png",
		)
		this.load.image("feedingPanel", "assets/images/cockpit/feedingPanel.png")
		this.load.image("taskHeader", "assets/images/cockpit/TaskHeader.png")
		this.load.image("emptyFood", "assets/images/cockpit/EmptyFood.png")
		this.load.image("taskListPanel", "assets/images/cockpit/taskListPanel.png")
		this.load.image("tubeFront", "assets/images/cockpit/tube_FRONT.png")
		this.load.image(
			"tubeFrontScaled",
			"assets/images/cockpit/tube_FRONT_Scaled.png",
		)
		this.load.image("tubeBack", "assets/images/cockpit/tube_BACK.png")
		this.load.image(
			"tubeBackScaled",
			"assets/images/cockpit/tube_BACK_Scaled.png",
		)

		this.load.image("taskActive", "assets/images/ui/TaskActive.png")
		this.load.image("taskInactive", "assets/images/ui/TaskInactive.png")
		this.load.image(
			"creatureTaskHolder",
			"assets/images/ui/CritterTaskHolder.png",
		)

		this.load.image("videoMask", "assets/images/ui/videoMask.png")

		//tooltips
		this.load.image("pressMeTip", "assets/images/tooltips/pressMeTipSmall.png")
		this.load.image("downMediumTip", "assets/images/tooltips/downMediumTip.png")
		this.load.image(
			"downMediumBigTip",
			"assets/images/tooltips/downMediumBigTip.png",
		)
		//troubleshootTip
		this.load.image("leftMediumTip", "assets/images/tooltips/leftMediumTip.png")
		this.load.image(
			"pressToScanTip",
			"assets/images/tooltips/pressToScanTip.png",
		)

		this.load.image(
			"troubleshootTip",
			"assets/images/tooltips/troubleshootTip.png",
		)

		this.load.image(
			"pressToZoomTip",
			"assets/images/tooltips/pressToZoomTip.png",
		)

		this.load.image(
			"ultraWideRightTip",
			"assets/images/tooltips/ultraWideRightTip.png",
		)
		this.load.image(
			"mediumChunkyLeftTip",
			"assets/images/tooltips/mediumChunkyLeftTip.png",
		)
		this.load.image(
			"mediumChunkyRightTip",
			"assets/images/tooltips/mediumChunkyRightTip.png",
		)
		this.load.image(
			"pageThroughTip",
			"assets/images/tooltips/pageThroughTip.png",
		)
		this.load.image("fetchTip", "assets/images/tooltips/FetchTooltip.png")
		this.load.image(
			"noBarcodeScanTip",
			"assets/images/tooltips/noBarcodeScanTip.png",
		)
		this.load.image(
			"highlightBarcodeTip",
			"assets/images/tooltips/highlightBarcodeTip.png",
		)
		this.load.image("stepBackTip", "assets/images/tooltips/stepBackTooltip.png")
		this.load.image("tabletTip", "assets/images/tooltips/tabletTip.png")
		this.load.image("dischargeTip", "assets/images/tooltips/dischargeTip.png")
		this.load.image("dischargeCrit", "assets/images/tooltips/DischargeCrit.png")
		this.load.image("buttonTip", "assets/images/indicators/buttonIndicator.png")
		this.load.image(
			"barcodeMatchTip",
			"assets/images/tooltips/barcodeMatchTip.png",
		)
		this.load.image(
			"pressTheDropDownTip",
			"assets/images/tooltips/pressTheDropDownTip.png",
		)
		this.load.image(
			"zoomTip",
			"assets/images/tooltips/zoomTip.png",
		)
		//creatureDetailsTip
		this.load.image(
			"creatureDetailsTip",
			"assets/images/tooltips/creatureDetailsTip.png",
		)
		//finishOtherCreatureTip
		this.load.image(
			"finishOtherCreatureTip",
			"assets/images/tooltips/finishOtherCreatureTip.png",
		)
		this.load.image(
			"closeFieldGuideTip",
			"assets/images/tooltips/closeFieldGuideTip.png",
		)
		this.load.image(
			"initiateLiftOffTip",
			"assets/images/tooltips/initiateLiftOffTip.png",
		)

		this.load.image("pickFoodTip", "assets/images/tooltips/pickFoodTip.png")
		this.load.image("foodIndicator", "assets/images/tooltips/foodTip.png")

		this.load.image(
			"logActivityTip",
			"assets/images/tooltips/logActivityTip.png",
		)

		// this.load.image("leftZoomed", "assets/images/cockpit/leftZoomed.png")
		// this.load.image("rightZoomed", "assets/images/cockpit/rightZoomed.png")
		this.load.image("leftZoomed", "assets/images/cockpit/Mediclinic_tube_BG.png")
		this.load.image("rightZoomed", "assets/images/cockpit/Mediclinic_tube_BG.png")

		this.load.image("appBackButton", "assets/images/ui/AppBarBackButton.png")
		this.load.image("tubeBack", "assets/images/cockpit/tube_BACK.png")
		this.load.image(
			"tubeBackScaled",
			"assets/images/cockpit/tube_BACK_Scaled.png",
		)

		this.load.image("dbAppBar", "assets/images/ui/DBAppBar.png")
		this.load.image("fieldGuideAppBar", "assets/images/ui/FieldGuideAppBar.png")
		this.load.image("emailAppBar", "assets/images/ui/EmailsAppBar.png")
		this.load.image("alertsAppBar", "assets/images/ui/AlertsAppBar.png")
		this.load.image("appBackButton", "assets/images/ui/AppBarBackButton.png")
		this.load.image("helpDeskAppBar", "assets/images/ui/HelpDeskTopBar.png")
		this.load.image("appCloseButton", "assets/images/ui/AppBarCloseButton.png")
		this.load.image("tabsHolder", "assets/images/ui/Tabs.png")
		this.load.image("activityActive", "assets/images/ui/ActivityActive.png")
		this.load.image("activityInactive", "assets/images/ui/ActivityInactive.png")
		this.load.image("detailsActive", "assets/images/ui/DetailsActive.png")
		this.load.image("detailsInactive", "assets/images/ui/DetailsInactive.png")
		this.load.image(
			"fieldGuideContainer",
			"assets/images/ui/fieldGuideContainer.png",
		)
		this.load.image("zoomBtn", "assets/images/ui/FullView.png")
		this.load.image(
			"blueAlertContainer",
			"assets/images/ui/blueAlertContainer.png",
		)
		this.load.image(
			"clearAlertWarning",
			"assets/images/ui/clearAlertWarning.png",
		)
		this.load.image(
			"blueAlertContainerSmall",
			"assets/images/ui/blueAlertContainerSmall.png",
		)
		this.load.image("navLeftButton", "assets/images/navBtns/navLeftButton.png")
		this.load.image(
			"navRightButton",
			"assets/images/navBtns/navRightButton.png",
		)
		this.load.image(
			"navSelectedButton",
			"assets/images/navBtns/selectedPage.png",
		)
		this.load.image(
			"navUnselectedButton",
			"assets/images/navBtns/unselectedPage.png",
		)
		//food
		this.load.image("food01_thumb", "assets/images/food/food1.png")
		this.load.image("food02_thumb", "assets/images/food/food2.png")
		this.load.image("food03_thumb", "assets/images/food/food3.png")
		this.load.image("food04_thumb", "assets/images/food/food4.png")
		this.load.image("food05_thumb", "assets/images/food/food5.png")
		this.load.image("food06_thumb", "assets/images/food/food6.png")
		this.load.image("food07_thumb", "assets/images/food/food7.png")
		this.load.image("food08_thumb", "assets/images/food/food8.png")
		this.load.image("food09_thumb", "assets/images/food/food9.png")
		this.load.image("food010_thumb", "assets/images/food/food10.png")
		this.load.image("emptyFoodTray", "assets/images/food/emptyFoodTray.png")

		//fieldGuide creature thumbs
		this.load.image(
			"fgCreature01Thumb",
			"assets/images/creatureFGThumbs/FGCreature01Thumb.png",
		)
		this.load.image(
			"fgCreature02Thumb",
			"assets/images/creatureFGThumbs/FGCreature02Thumb.png",
		)
		this.load.image(
			"fgCreature03Thumb",
			"assets/images/creatureFGThumbs/FGCreature03Thumb.png",
		)
		this.load.image(
			"fgCreature04Thumb",
			"assets/images/creatureFGThumbs/FGCreature04Thumb.png",
		)
		this.load.image(
			"fgCreature05Thumb",
			"assets/images/creatureFGThumbs/FGCreature05Thumb.png",
		)
		this.load.image(
			"fgCreature06Thumb",
			"assets/images/creatureFGThumbs/FGCreature06Thumb.png",
		)
		this.load.image(
			"fgCreature07Thumb",
			"assets/images/creatureFGThumbs/FGCreature07Thumb.png",
		)
		this.load.image(
			"fgCreature08Thumb",
			"assets/images/creatureFGThumbs/FGCreature08Thumb.png",
		)
		this.load.image(
			"fgCreature09Thumb",
			"assets/images/creatureFGThumbs/FGCreature09Thumb.png",
		)
		this.load.image(
			"fgCreature10Thumb",
			"assets/images/creatureFGThumbs/FGCreature10Thumb.png",
		)
		this.load.image(
			"fgCreature11Thumb",
			"assets/images/creatureFGThumbs/FGCreature11Thumb.png",
		)
		this.load.image(
			"fgCreature12Thumb",
			"assets/images/creatureFGThumbs/FGCreature12Thumb.png",
		)
		this.load.image(
			"fgCreature13Thumb",
			"assets/images/creatureFGThumbs/FGCreature13Thumb.png",
		)
		this.load.image(
			"fgCreature14Thumb",
			"assets/images/creatureFGThumbs/FGCreature14Thumb.png",
		)
		this.load.image(
			"fgCreature15Thumb",
			"assets/images/creatureFGThumbs/FGCreature15Thumb.png",
		)
		this.load.image(
			"fgCreature16Thumb",
			"assets/images/creatureFGThumbs/FGCreature16Thumb.png",
		)
		this.load.image(
			"fgCreature17Thumb",
			"assets/images/creatureFGThumbs/FGCreature17Thumb.png",
		)
		this.load.image(
			"fgCreature18Thumb",
			"assets/images/creatureFGThumbs/FGCreature18Thumb.png",
		)

		// load creature images
		this.load.image(
			"creature01_fed",
			"assets/images/creatures/Creature01_fed.png",
		)
		this.load.image(
			"creature02_fed",
			"assets/images/creatures/Creature02_fed.png",
		)
		this.load.image(
			"creature03_fed",
			"assets/images/creatures/Creature03_fed.png",
		)
		this.load.image(
			"creature04_fed",
			"assets/images/creatures/Creature04_fed.png",
		)
		this.load.image(
			"creature05_fed",
			"assets/images/creatures/Creature05_fed.png",
		)
		this.load.image(
			"creature06_fed",
			"assets/images/creatures/Creature06_fed.png",
		)
		this.load.image(
			"creature07_fed",
			"assets/images/creatures/Creature07_fed.png",
		)
		this.load.image(
			"creature08_fed",
			"assets/images/creatures/Creature08_fed.png",
		)
		this.load.image(
			"creature09_fed",
			"assets/images/creatures/Creature09_fed.png",
		)
		this.load.image(
			"creature10_fed",
			"assets/images/creatures/Creature10_fed.png",
		)
		this.load.image(
			"creature11_fed",
			"assets/images/creatures/Creature11_fed.png",
		)
		this.load.image(
			"creature12_fed",
			"assets/images/creatures/Creature12_fed.png",
		)
		this.load.image(
			"creature13_fed",
			"assets/images/creatures/Creature13_fed.png",
		)
		this.load.image(
			"creature14_fed",
			"assets/images/creatures/Creature14_fed.png",
		)
		this.load.image(
			"creature15_fed",
			"assets/images/creatures/Creature15_fed.png",
		)
		this.load.image(
			"creature16_fed",
			"assets/images/creatures/Creature16_fed.png",
		)
		this.load.image(
			"creature17_fed",
			"assets/images/creatures/Creature17_fed.png",
		)
		this.load.image(
			"creature18_fed",
			"assets/images/creatures/Creature18_fed.png",
		)

		this.load.image(
			"outroGlossary",
			"assets/images/ui/outroGlossary.png",
		)

		// Load common JSON data
		this.load.json("userGameData", "assets/json/userGameData.json")
		this.load.json("creatureData", "assets/json/creatures.json")
		this.load.json("emailsAndAlerts", "assets/json/emailsAndAlerts.json")
		this.load.json("learningOutcomes", "assets/json/learningOutcomes.json")

		// Load common audio
		this.load.audio(
			"driftingInSpace",
			"assets/sound/Ambiances/Drifting in Space Ambiance.mp3",
		)
		this.load.audio("blib", "assets/sound/SFX/UI/blib.mp3")
		this.load.audio("Click-pop1", "assets/sound/SFX/UI/Click-pop1.mp3")
		this.load.audio("Error3", "assets/sound/SFX/UI/Error3.mp3")
		this.load.audio("Subtle click 1", "assets/sound/SFX/UI/Subtle click 1.mp3")
		this.load.audio(
			"space-firing-up",
			"assets/sound/SFX/Spacecraft/Spacecraft firing up.mp3",
		)
		this.load.audio("success-audio", "assets/sound/SFX/UI/Boop2.mp3")
		this.load.audio("radar-sonar-ping", "assets/sound/SFX/UI/TabletClose.mp3")
		this.load.audio("put-away-tablet", "assets/sound/SFX/UI/Swoosh-Ffft.mp3")
		this.load.audio("open-tablet", "assets/sound/SFX/UI/Popup Boop.mp3")
		this.load.audio(
			"space-landing-up",
			"assets/sound/SFX/Spacecraft/SCraft Landing short.mp3",
		)
		this.load.audio(
			"Computer_data_sound",
			"assets/sound/SFX/Spacecraft/Computer data sound.mp3",
		)
		this.load.audio(
			"spacething_teleporting",
			"assets/sound/SFX/Spacecraft/Spacething teleporting.mp3",
		)
		this.load.audio(
			"Muzac_bad_speaker",
			"assets/sound/Muzac/Muzac bad speaker Radio bounce.mp3",
		)

		//atlases
		this.load.atlas(
			"creatureScan",
			"assets/images/spriteSheets/creature_scan.png",
			"assets/images/spriteSheets/creature_scan.json",
		)
		this.load.atlas(
			"radarScan",
			"assets/images/spriteSheets/radar.png",
			"assets/images/spriteSheets/radar.json",
		)

		this.load.atlas(
			'appUnlock',
			'assets/images/Juice/Juice_app_unlock/Juice_app_unlock.png',
			'assets/images/Juice/Juice_app_unlock/Juice_app_unlock.json'
		)

		this.load.atlas(
			'pipPopUp',
			'assets/images/Juice/Juice_pip_pop/Juice_pip_pop.png',
			'assets/images/Juice/Juice_pip_pop/Juice_pip_pop.json'
		)

		this.load.atlas(
			'scrollIndicator',
			'assets/images/Juice/Juice_scroll_indicator/Juice_scroll_indicator.png',
			'assets/images/Juice/Juice_scroll_indicator/Juice_scroll_indicator.json'
		)

		this.load.atlas(
			'tickJuice',
			'assets/images/Juice/Juice_tick/Juice_tick.png',
			'assets/images/Juice/Juice_tick/Juice_tick.json'
		)

		this.load.atlas(
			'planetUnlock',
			'assets/images/Juice/Juice_planet_unlock/Juice_planet_unlock.png',
			'assets/images/Juice/Juice_planet_unlock/Juice_planet_unlock.json'
		)

		this.load.image("dropDownTut", "assets/images/ui/dropDownTut.png")
		this.load.image("scrollTut", "assets/images/ui/scrollTut.png")

		//tubeLabels
		this.load.image("tube1Label", "assets/images/ui/tube1Label.png")
		this.load.image("tube2Label", "assets/images/ui/tube2Label.png")
		this.load.image("tube1LabelSmall", "assets/images/ui/tube1LabelSmall.png")
		this.load.image("tube2LabelSmall", "assets/images/ui/tube2LabelSmall.png")
		this.load.image("hand", "assets/images/ui/Hand.png")
		this.load.image("tutorialTip", "assets/images/ui/TutorialTip.png")
		this.load.image("okBtn_", "assets/images/ui/okBtn.png")
		this.load.image("basicContainer", "assets/images/ui/basicContainer.png")
		this.load.image("radarInst", "assets/images/ui/radarInst.png")

		// Load plugins
		this.load.plugin(
			"rexbbcodetextplugin",
			"https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexbbcodetextplugin.min.js",
			true,
		)

		//learning outcome images
		this.load.image("mouse", "assets/images/Learning Outcome stills/a mouse.png")
		this.load.image("printer", "assets/images/Learning Outcome stills/a printer.png")
		this.load.image("desktops", "assets/images/Learning Outcome stills/desktops.png")
		this.load.image("email", "assets/images/Learning Outcome stills/email.png")
		this.load.image("entering", "assets/images/Learning Outcome stills/entering numbers letters.png")
		this.load.image("forms", "assets/images/Learning Outcome stills/forms.png")
		this.load.image("help desk", "assets/images/Learning Outcome stills/help desk.png")
		this.load.image("laptops", "assets/images/Learning Outcome stills/laptops.png")
		this.load.image("logging time", "assets/images/Learning Outcome stills/logging time.png")
		this.load.image("otp", "assets/images/Learning Outcome stills/otp.png")
		this.load.image("required fields", "assets/images/Learning Outcome stills/required fields.png")
		this.load.image("wifi", "assets/images/Learning Outcome stills/wi fi.png")
		//this.load.image("open-close program", "assets/images/Learning Outcome stills/open-close program.png")

	}

	loadPlanet1Assets(scene) {
		// if (this.loadingText) {
		// 	//this.loadingText.setText("Loading Planet 1: Hypothera...")
		// }
		console.log("Planet 1 loading")

		// Create a new loader for background loading
		const backgroundLoader = scene.load

		// Planet 1 specific assets
		backgroundLoader.image("welcomeTip", "assets/images/ui/WelcomeTip.png")
		backgroundLoader.image("tutorialTip", "assets/images/ui/TutorialTip.png")
		backgroundLoader.image("radarTip", "assets/images/ui/RadarTip.png")
		backgroundLoader.image("fuelTip", "assets/images/ui/FuelTip.png")

		backgroundLoader.image(
			'pressActivityTabTip',
			"assets/images/tooltips/pressActivityLogTip.png",
		)

		backgroundLoader.image("planet01", "assets/images/planets/Planet_1.png")
		backgroundLoader.image(
			"planet01Wide",
			"assets/images/planetBackgrounds/Planet1_wide.png",
		)
		backgroundLoader.image(
			"planet01Close",
			"assets/images/planetBackgrounds/Planet1_close.png",
		)
		backgroundLoader.image(
			"hypotheraPanel",
			"assets/images/planetNamePanels/hypotheraPanel.png",
		)
		backgroundLoader.image(
			"cockpitFront_1",
			"assets/images/cockpit/Cockpit_Front_1.png",
		)
		backgroundLoader.image(
			"tubeL_1",
			"assets/images/cockpit/Cockpit_Left_1.png",
		)
		backgroundLoader.image(
			"tubeR_1",
			"assets/images/cockpit/Cockpit_Right_1.png",
		)
		backgroundLoader.image(
			"rightZoomed1",
			"assets/images/cockpit/Mediclinic_tube_BG.png",
		)

		backgroundLoader.image("tubeL", "assets/images/cockpit/Cockpit_Left.png")
		backgroundLoader.image("tubeR", "assets/images/cockpit/Cockpit_Right.png")
		backgroundLoader.image(
			"cockpitFront",
			"assets/images/cockpit/Cockpit_Front.png",
		)

		//db creature thumbs
		// backgroundLoader.image(
		// 	"dbCreature01Thumb",
		// 	"assets/images/creatureDBThumbs/dbCreature01thumb.png",
		// )
		// backgroundLoader.image(
		// 	"dbCreature02Thumb",
		// 	"assets/images/creatureDBThumbs/dbCreature02thumb.png",
		// )

		backgroundLoader.image("alertsToggleOff", "assets/images/ui/ToggleOff.png")
		backgroundLoader.image("alertsToggleOn", "assets/images/ui/ToggleOn.png")
		backgroundLoader.image("scanError", "assets/images/ui/scanError.png")
		backgroundLoader.atlas(
			"bioScan",
			"assets/images/spriteSheets/bioscan.png",
			"assets/images/spriteSheets/bioscan.json",
		)

		// Planet 1 creatures (creatures 1-3 for example)
		backgroundLoader.image(
			"creature01_hungry",
			"assets/images/creatures/Creature01_hungry.png",
		)
		backgroundLoader.image(
			"creature01_thumb",
			"assets/images/creatureThumbs/Creature01_thumbnail.png",
		)
		backgroundLoader.image(
			"creature01_GalleryActive",
			"assets/images/galleryThumbs/creature01GalleryActive.png",
		)
		backgroundLoader.image(
			"creature01_GalleryLocked",
			"assets/images/galleryThumbs/creature01GalleryLocked.png",
		)
		backgroundLoader.image(
			"creature01_GalleryDischarged",
			"assets/images/galleryThumbs/creature01GalleryDischarged.png",
		)

		backgroundLoader.image(
			"creature02_hungry",
			"assets/images/creatures/Creature02_hungry.png",
		)
		backgroundLoader.image(
			"creature02_thumb",
			"assets/images/creatureThumbs/Creature02_thumbnail.png",
		)
		backgroundLoader.image(
			"creature02_GalleryActive",
			"assets/images/galleryThumbs/creature02GalleryActive.png",
		)
		backgroundLoader.image(
			"creature02_GalleryLocked",
			"assets/images/galleryThumbs/creature02GalleryLocked.png",
		)
		backgroundLoader.image(
			"creature02_GalleryDischarged",
			"assets/images/galleryThumbs/creature02GalleryDischarged.png",
		)

		// Planet 1 database thumbnails
		backgroundLoader.image(
			"dbCreature01Thumb",
			"assets/images/creatureDBThumbs/dbCreature01thumb.png",
		)
		backgroundLoader.image(
			"dbCreature02Thumb",
			"assets/images/creatureDBThumbs/dbCreature02thumb.png",
		)

		// Planet 1 name tags
		backgroundLoader.image(
			"frostStalkerTag",
			"assets/images/nameTags/frostStalkerTag.png",
		)
		backgroundLoader.image(
			"iceCrawlerTag",
			"assets/images/nameTags/iceCrawlerTag.png",
		)

		backgroundLoader.image("faceBG", "assets/images/ui/faceBG.png")

		// Planet 1 specific audio
		backgroundLoader.audio(
			"desert_moon_ambiance",
			"assets/sound/SFX/Spacecraft/Desert moon ambiance.mp3",
		)

		backgroundLoader.once("complete", () => {
			this.planetAssetsLoaded.planet1 = true
			console.log("Planet 1 assets loaded!")
			this.events.emit("planet1-loaded")

			// Start loading Planet 2 assets
			//this.loadPlanet2Assets(scene)
		})

		backgroundLoader.start()
	}

	loadPlanet2Assets(scene) {
		if (this.planetAssetsLoaded.planet2) return

		console.log("Loading Planet 2 assets in background...")

		// Create a new loader for background loading
		const backgroundLoader = scene.load

		// Planet 2 specific assets
		backgroundLoader.image("planet02", "assets/images/planets/Planet_2.png")
		backgroundLoader.image(
			"planet02Locked",
			"assets/images/planets/Planet_2Locked.png",
		)
		backgroundLoader.image(
			"planet02Wide",
			"assets/images/planetBackgrounds/Planet2_wide.png",
		)
		backgroundLoader.image(
			"planet02Close",
			"assets/images/planetBackgrounds/Planet2_close.png",
		)
		backgroundLoader.image(
			"stratosomaPanel",
			"assets/images/planetNamePanels/stratosomaPanel.png",
		)
		backgroundLoader.image(
			"cockpitFront_2",
			"assets/images/cockpit/Cockpit_Front_2.png",
		)
		backgroundLoader.image(
			"tubeL_2",
			"assets/images/cockpit/Cockpit_Left_2.png",
		)
		backgroundLoader.image(
			"tubeR_2",
			"assets/images/cockpit/Cockpit_Right_2.png",
		)
		backgroundLoader.image(
			"rightZoomed2",
			"assets/images/cockpit/Mediclinic_tube_BG.png",
		)

		// Planet 2 database thumbs
		backgroundLoader.image(
			"dbCreature03Thumb",
			"assets/images/creatureDBThumbs/dbCreature03thumb.png",
		)
		backgroundLoader.image(
			"dbCreature04Thumb",
			"assets/images/creatureDBThumbs/dbCreature04thumb.png",
		)
		backgroundLoader.image(
			"dbCreature05Thumb",
			"assets/images/creatureDBThumbs/dbCreature05thumb.png",
		)

		// Planet 2 creatures (creatures 4-6)
		backgroundLoader.image(
			"creature03_hungry",
			"assets/images/creatures/Creature03_hungry.png",
		)

		backgroundLoader.image(
			"creature03_thumb",
			"assets/images/creatureThumbs/Creature03_thumbnail.png",
		)
		backgroundLoader.image(
			"creature03_GalleryActive",
			"assets/images/galleryThumbs/creature03GalleryActive.png",
		)
		backgroundLoader.image(
			"creature03_GalleryLocked",
			"assets/images/galleryThumbs/creature03GalleryLocked.png",
		)
		backgroundLoader.image(
			"creature03_GalleryDischarged",
			"assets/images/galleryThumbs/creature03GalleryDischarged.png",
		)

		backgroundLoader.image(
			"creature04_hungry",
			"assets/images/creatures/Creature04_hungry.png",
		)

		backgroundLoader.image(
			"creature04_thumb",
			"assets/images/creatureThumbs/Creature04_thumbnail.png",
		)
		backgroundLoader.image(
			"creature04_GalleryActive",
			"assets/images/galleryThumbs/creature04GalleryActive.png",
		)
		backgroundLoader.image(
			"creature04_GalleryLocked",
			"assets/images/galleryThumbs/creature04GalleryLocked.png",
		)
		backgroundLoader.image(
			"creature04_GalleryDischarged",
			"assets/images/galleryThumbs/creature04GalleryDischarged.png",
		)

		backgroundLoader.image(
			"creature05_hungry",
			"assets/images/creatures/Creature05_hungry.png",
		)

		backgroundLoader.image(
			"creature05_thumb",
			"assets/images/creatureThumbs/Creature05_thumbnail.png",
		)
		backgroundLoader.image(
			"creature05_GalleryActive",
			"assets/images/galleryThumbs/creature05GalleryActive.png",
		)
		backgroundLoader.image(
			"creature05_GalleryLocked",
			"assets/images/galleryThumbs/creature05GalleryLocked.png",
		)
		backgroundLoader.image(
			"creature05_GalleryDischarged",
			"assets/images/galleryThumbs/creature05GalleryDischarged.png",
		)

		// Planet 2 field guide thumbnails
		// backgroundLoader.image("fgCreature04Thumb", "assets/images/creatureFGThumbs/FGCreature04Thumb.png")
		// backgroundLoader.image("fgCreature05Thumb", "assets/images/creatureFGThumbs/FGCreature05Thumb.png")
		// backgroundLoader.image("fgCreature06Thumb", "assets/images/creatureFGThumbs/FGCreature06Thumb.png")

		// Planet 2 name tags
		backgroundLoader.image(
			"driftBackTag",
			"assets/images/nameTags/driftBackTag.png",
		)
		backgroundLoader.image(
			"cloudStriderTag",
			"assets/images/nameTags/cloudStrider.png",
		)
		backgroundLoader.image("skyRayTag", "assets/images/nameTags/skyRayTag.png")

		// Planet 2 specific audio
		backgroundLoader.audio(
			"water_fall_ambiance",
			"assets/sound/SFX/Spacecraft/Waterfall Planet Ambiance.mp3",
		)

		//alerts
		backgroundLoader.image("burgerButton", "assets/images/ui/burgerButton.png")
		backgroundLoader.image("playButton", "assets/images/ui/playButton.png")
		backgroundLoader.image(
			"shutDownButton",
			"assets/images/ui/shutDownButton.png",
		)
		backgroundLoader.image(
			"alertShutPillsDefault",
			"assets/images/ui/alertShutPillsDefault.png",
		)
		backgroundLoader.image(
			"alertShutPillsPressed",
			"assets/images/ui/alertShutPillsPressed.png",
		)
		backgroundLoader.image(
			"alertSleepPressed",
			"assets/images/ui/alertSleepPressed.png",
		)
		backgroundLoader.image(
			"alertRecentPressed",
			"assets/images/ui/alertRecentPressed.png",
		)
		//mouseSelect
		backgroundLoader.image("mouse1", "assets/images/mouseSelect/mouse1.png")
		backgroundLoader.image("mouse2", "assets/images/mouseSelect/mouse2.png")
		backgroundLoader.image("mouse3", "assets/images/mouseSelect/mouse3.png")
		backgroundLoader.image("mouse4", "assets/images/mouseSelect/mouse4.png")
		backgroundLoader.image("mouse5", "assets/images/mouseSelect/mouse5.png")
		backgroundLoader.image("mouse6", "assets/images/mouseSelect/mouse6.png")
		backgroundLoader.image("mouse7", "assets/images/mouseSelect/mouse7.png")
		backgroundLoader.image("mouse8", "assets/images/mouseSelect/mouse8.png")
		backgroundLoader.image("mouse9", "assets/images/mouseSelect/mouse9.png")

		//printerSelect
		backgroundLoader.image(
			"printer1",
			"assets/images/printerSelect/printer1.png",
		)
		backgroundLoader.image(
			"printer2",
			"assets/images/printerSelect/printer2.png",
		)
		backgroundLoader.image(
			"printer3",
			"assets/images/printerSelect/printer3.png",
		)
		backgroundLoader.image(
			"printer4",
			"assets/images/printerSelect/printer4.png",
		)
		backgroundLoader.image(
			"printer5",
			"assets/images/printerSelect/printer5.png",
		)
		backgroundLoader.image(
			"printer6",
			"assets/images/printerSelect/printer6.png",
		)
		backgroundLoader.image(
			"printer7",
			"assets/images/printerSelect/printer7.png",
		)
		backgroundLoader.image(
			"printer8",
			"assets/images/printerSelect/printer8.png",
		)
		backgroundLoader.image(
			"printer9",
			"assets/images/printerSelect/printer9.png",
		)

		backgroundLoader.once("complete", () => {
			this.planetAssetsLoaded.planet2 = true
			console.log("Planet 2 assets loaded!")
			this.events.emit("planet2-loaded")

			// Start loading Planet 3 assets
			//this.loadPlanet3Assets(scene)
		})

		backgroundLoader.start()
	}

	// Fix 3: Update loadPlanet3Assets method
	loadPlanet3Assets(scene) {
		if (this.planetAssetsLoaded.planet3) return

		console.log("Loading Planet 3 assets in background...")

		// Create a new loader for background loading
		// const backgroundLoader = new Phaser.Loader.LoaderPlugin(this)
		const backgroundLoader = scene.load

		// Planet 3 specific assets
		backgroundLoader.image(
			"helpDeskButton",
			"assets/images/ui/HelpDeskButton.png",
		)
		backgroundLoader.image("planet03", "assets/images/planets/Planet_3.png")
		backgroundLoader.image(
			"planet03Locked",
			"assets/images/planets/Planet_3Locked.png",
		)
		backgroundLoader.image(
			"planet03Wide",
			"assets/images/planetBackgrounds/Planet3_wide.png",
		)
		backgroundLoader.image(
			"planet03Close",
			"assets/images/planetBackgrounds/Planet3_close.png",
		)
		backgroundLoader.image(
			"emberonPanel",
			"assets/images/planetNamePanels/emberonPanel.png",
		)
		backgroundLoader.image(
			"cockpitFront_3",
			"assets/images/cockpit/Cockpit_Front_3.png",
		)
		backgroundLoader.image(
			"tubeL_3",
			"assets/images/cockpit/Cockpit_Left_3.png",
		)
		backgroundLoader.image(
			"tubeR_3",
			"assets/images/cockpit/Cockpit_Right_3.png",
		)
		backgroundLoader.image(
			"rightZoomed3",
			"assets/images/cockpit/Mediclinic_tube_BG.png",
		)

		// Planet 3 database thumbs
		backgroundLoader.image(
			"dbCreature06Thumb",
			"assets/images/creatureDBThumbs/dbCreature06thumb.png",
		)
		backgroundLoader.image(
			"dbCreature07Thumb",
			"assets/images/creatureDBThumbs/dbCreature07thumb.png",
		)
		backgroundLoader.image(
			"dbCreature08Thumb",
			"assets/images/creatureDBThumbs/dbCreature08thumb.png",
		)

		// Planet 3 creatures (creatures 6-8)
		backgroundLoader.image(
			"creature06_hungry",
			"assets/images/creatures/Creature06_hungry.png",
		)

		backgroundLoader.image(
			"creature06_thumb",
			"assets/images/creatureThumbs/Creature06_thumbnail.png",
		)
		backgroundLoader.image(
			"creature06_GalleryActive",
			"assets/images/galleryThumbs/creature06GalleryActive.png",
		)
		backgroundLoader.image(
			"creature06_GalleryLocked",
			"assets/images/galleryThumbs/creature06GalleryLocked.png",
		)
		backgroundLoader.image(
			"creature06_GalleryDischarged",
			"assets/images/galleryThumbs/creature06GalleryDischarged.png",
		)

		backgroundLoader.image(
			"creature07_hungry",
			"assets/images/creatures/Creature07_hungry.png",
		)

		backgroundLoader.image(
			"creature07_thumb",
			"assets/images/creatureThumbs/Creature07_thumbnail.png",
		)
		backgroundLoader.image(
			"creature07_GalleryActive",
			"assets/images/galleryThumbs/creature07GalleryActive.png",
		)
		backgroundLoader.image(
			"creature07_GalleryLocked",
			"assets/images/galleryThumbs/creature07GalleryLocked.png",
		)
		backgroundLoader.image(
			"creature07_GalleryDischarged",
			"assets/images/galleryThumbs/creature07GalleryDischarged.png",
		)

		backgroundLoader.image(
			"creature08_hungry",
			"assets/images/creatures/Creature08_hungry.png",
		)

		backgroundLoader.image(
			"creature08_thumb",
			"assets/images/creatureThumbs/Creature08_thumbnail.png",
		)
		backgroundLoader.image(
			"creature08_GalleryActive",
			"assets/images/galleryThumbs/creature08GalleryActive.png",
		)
		backgroundLoader.image(
			"creature08_GalleryLocked",
			"assets/images/galleryThumbs/creature08GalleryLocked.png",
		)
		backgroundLoader.image(
			"creature08_GalleryDischarged",
			"assets/images/galleryThumbs/creature08GalleryDischarged.png",
		)

		backgroundLoader.image("scanError", "assets/images/ui/scanError.png")		

		// Planet 3 field guide thumbnails
		// backgroundLoader.image("fgCreature06Thumb", "assets/images/creatureFGThumbs/FGCreature06Thumb.png")
		// backgroundLoader.image("fgCreature07Thumb", "assets/images/creatureFGThumbs/FGCreature07Thumb.png")
		// backgroundLoader.image("fgCreature08Thumb", "assets/images/creatureFGThumbs/FGCreature08Thumb.png")

		// Planet 3 name tags
		backgroundLoader.image(
			"obsidianSnailTag",
			"assets/images/nameTags/obsidianSnailTag.png",
		)
		backgroundLoader.image(
			"blazeWraithTag",
			"assets/images/nameTags/blazeWraith.png",
		)
		backgroundLoader.image("smothTag", "assets/images/nameTags/smothTag.png")

		backgroundLoader.image(
			"wifiDisconnected",
			"assets/images/ui/wifiDisconnected.png",
		)
		backgroundLoader.image(
			"wifiDisconnected2",
			"assets/images/ui/wifiDisconnected2.png",
		)
		backgroundLoader.image(
			"wifiDisconnected3",
			"assets/images/ui/wifiDisconnected3.png",
		)
		backgroundLoader.image(
			"wifiDisconnected4",
			"assets/images/ui/wifiDisconnected4.png",
		)
		backgroundLoader.image("wrongWifi00", "assets/images/ui/wrongWifi00.png")
		backgroundLoader.image("wrongWifi01", "assets/images/ui/wrongWifi01.png")
		backgroundLoader.image(
			"alertRobotHeader",
			"assets/images/ui/alertRobotHeader.png",
		)
		backgroundLoader.image("creatureSkin", "assets/images/ui/creatureSkin.png")
		backgroundLoader.image("barcodeScan", "assets/images/ui/barcodeScan.png")
		backgroundLoader.image(
			"movingBarcode",
			"assets/images/ui/movingBarcode.png",
		)
		backgroundLoader.image(
			"barcodeChecker",
			"assets/images/ui/barcodeChecker.png",
		)
		backgroundLoader.image(
			"barcodeSuccess",
			"assets/images/ui/barcodeSuccesful.png",
		)
		backgroundLoader.image("alertDesktop", "assets/images/ui/alertDesktop.png")
		backgroundLoader.image("alertLaptop", "assets/images/ui/alertLaptop.png")
		backgroundLoader.image(
			"alertLaptopContainer",
			"assets/images/ui/alertLaptopContainer.png",
		)
		backgroundLoader.image(
			"alertPcContainer",
			"assets/images/ui/alertPcContainer.png",
		)
		backgroundLoader.image(
			"alertLaptopHeader",
			"assets/images/ui/alertLaptopHeader.png",
		)
		backgroundLoader.image(
			"alertDesktopHeader",
			"assets/images/ui/alertDesktopHeader.png",
		)
		//howToScanPanel
		backgroundLoader.image(
			"howToScanPanel",
			"assets/images/ui/howToScanPanel.png",
		)
		backgroundLoader.image(
			"alertRobotHeader",
			"assets/images/ui/alertRobotHeader.png",
		)
		backgroundLoader.image("creatureSkin", "assets/images/ui/creatureSkin.png")
		backgroundLoader.image("barcodeScan", "assets/images/ui/barcodeScan.png")
		backgroundLoader.image(
			"movingBarcode",
			"assets/images/ui/movingBarcode.png",
		)
		backgroundLoader.image(
			"barcodeChecker",
			"assets/images/ui/barcodeChecker.png",
		)
		backgroundLoader.image(
			"barcodeSuccess",
			"assets/images/ui/barcodeSuccesful.png",
		)
		backgroundLoader.image(
			"alertOTPHeader",
			"assets/images/ui/alertOTPHeader.png",
		)
		backgroundLoader.image(
			"alertOTPHeaderWrong",
			"assets/images/ui/alertOTPHeaderWrong.png",
		)
		backgroundLoader.image(
			"alertOTPHeaderCorrect",
			"assets/images/ui/alertOtpHeaderCorrect.png",
		)
		backgroundLoader.image("otpCorrect", "assets/images/ui/otpCorrect.png")
		backgroundLoader.image("otpError", "assets/images/ui/otpError.png")
		backgroundLoader.image(
			"dropDownOpened",
			"assets/images/ui/dropDownOpened.png",
		)
		backgroundLoader.image(
			"dropDownClosed",
			"assets/images/ui/dropDownClosed.png",
		)

		// Planet 3 specific audio
		backgroundLoader.audio(
			"volcanic_ambiance",
			"assets/sound/SFX/Spacecraft/Volcanic planet.mp3",
		)

		backgroundLoader.once("complete", () => {
			this.planetAssetsLoaded.planet3 = true
			console.log("Planet 3 assets loaded!")
			this.events.emit("planet3-loaded")
		})

		backgroundLoader.start()
	}
	create() {
		// Start background loading of Planet 2 assets
		this.time.delayedCall(1000, () => {
			this.loadPlanet2Assets()
		})

		// Launch the game
		this.scene.launch("GameUI")
		this.scene.start("StartScene")
	}

	// Method to check if planet assets are loaded
	isPlanetReady(planetNumber) {
		switch (planetNumber) {
			case 1:
				return this.planetAssetsLoaded.planet1
			case 2:
				return this.planetAssetsLoaded.planet2
			case 3:
				return this.planetAssetsLoaded.planet3
			default:
				return false
		}
	}

	// Method to force load planet assets if needed
	ensurePlanetLoaded(scene, planetNumber, callback) {
		switch (planetNumber) {
			case 1:
				if (this.planetAssetsLoaded.planet1) {
					callback()
				} else {
					// Create a one-time listener for when planet 2 loads
					this.events.once("planet1-loaded", callback)
					this.loadPlanet1Assets(scene)
				}
				break
			case 2:
				if (this.planetAssetsLoaded.planet2) {
					callback()
				} else {
					// Create a one-time listener for when planet 2 loads
					this.events.once("planet2-loaded", callback)
					this.loadPlanet2Assets(scene)
				}
				break
			case 3:
				if (this.planetAssetsLoaded.planet3) {
					callback()
				} else {
					// Create a one-time listener for when planet 3 loads
					this.events.once("planet3-loaded", callback)
					this.loadPlanet3Assets(scene)
				}
				break
			default:
				callback()
		}
	}
}
